// Nível de experiência em advocacia do cadastro: valores aceitos pelo backend (NivelExperienciaAdvocacia)
// e rótulos mostrados ao candidato e ao RH.
export const NIVEIS_EXPERIENCIA = [
  ['junior', 'Júnior'],
  ['pleno', 'Pleno'],
  ['senior', 'Sênior'],
  ['nenhum', 'Nenhum'],
]

export function nivelExperienciaLabel(value) {
  return NIVEIS_EXPERIENCIA.find(([key]) => key === value)?.[1] || 'Não informado'
}
